import { Navigate, useLocation } from "react-router-dom";
import { isDebug } from "../utils";

const withAuthRoutes = [
  // "/mypage",
  // "/mypage/디테일",
];
const withoutAuthRoutes = [
  "/",
  "/intro",
  "/search",
  "/detail/:coffee_key_id",
  "/statistics",
  "/login",
];

if (isDebug()) console.log("##### Navigate", Navigate);

export default function AuthGuard({ children }) {
  const access = sessionStorage.getItem("access");
  const refresh = sessionStorage.getItem("refresh");
  const isLoggedIn = access && refresh;
  const { pathname } = useLocation();

  if (isDebug()) console.log("##### isLoggedIn:", isLoggedIn);
  if (isDebug()) console.log("##### pathname:", pathname);

  if (withAuthRoutes.includes(pathname) && !isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
